<template>
  <div class="about" v-html="content"></div>
</template>

<script>
export default {
  data() {
    return {
      content:''
    }
  },
  methods:{
    async created() {
      let res = await this.$apis.loginServe.getPrivacy();
      this.content = res.content.detail[0].content;
    },
  },
  mounted() {
    this.created()
  }
};
</script>

<style scoped lang="scss">
.about {
  margin: 0 auto;
  padding: 50px;
  width: 1200px;
  min-height: 840px;
  background: #ffffff;
  border: 1px solid #a3cbe7;
  border-radius: 10px;
  font-size: 15px;
  color: #333;
  line-height: 30px;
}
</style>